module.exports = __webpack_public_path__ + "img/list-b.ce5d2969.svg";